import React from "react";
import PropTypes from "prop-types";
import { IoPeopleOutline } from "@react-icons/all-files/io5/IoPeopleOutline";
import { FaPlus } from "@react-icons/all-files/fa6/FaPlus";
import { FaMinus } from "@react-icons/all-files/fa6/FaMinus";
import { Button } from 'day8-ui';
import { getSelectedFilters, onFilterSelect } from "../../../../helpers/filter";
import { CREW, FILTERS } from "../../../../constants";
import history from "../../../../history";
import { handleCrewChange } from "../../../../helpers/crew";
import { useDispatch } from "react-redux";

const Crew = props => {
  const dispatch = useDispatch();
  const selectedFilters = getSelectedFilters(props.location);
  const boys = +selectedFilters.boys || 0;
  const girls = +selectedFilters.girls || 0;
  const host = +selectedFilters.hostess || 0;
  const guests = boys + girls;
  const selectedFilterText = `${guests} guests, ${host} host, 1 skipper`;
  // Used to render FilterMenu list of all filters - we need this for reliably rendering 'selectedFilterText'
  return props.mobile ? (
    <div className={props.className}>
      <div>
        <div className="dui-flex dui-justify-between dui-items-center dui-w-full">
          <div>
            <p className="">Guests</p>
          </div>
          <div className="dui-flex dui-items-center dui-gap-4">
            <Button buttonType="SECONDARY" buttonSize="EXTRA_SMALL" rightIcon={<FaMinus />} onClick={() => handleCrewChange(boys, girls, -1, 0, CREW.MAX_GUESTS)} disabled={guests <= 1} />
            <span className='dui-w-4 dui-text-center'>{guests}</span>
            <Button buttonType="SECONDARY" buttonSize="EXTRA_SMALL" rightIcon={<FaPlus />} onClick={() => handleCrewChange(boys, girls, +1, 0, CREW.MAX_GUESTS)} disabled={guests >= CREW.MAX_GUESTS} />
          </div>
        </div>
        <div className="dui-flex dui-justify-between dui-items-center dui-w-full dui-mt-4">
          <div>
            <p>Host</p>
          </div>
          <div className="dui-flex dui-items-center dui-gap-4">
            <Button
              buttonType="SECONDARY"
              buttonSize="EXTRA_SMALL"
              rightIcon={<FaMinus />}
              onClick={() =>
                onFilterSelect(
                  history.location,
                  dispatch,
                  props.filterAction,
                  FILTERS.HOST,
                  host - 1
                )
              }
              disabled={!host}
            />
            <span className='dui-w-4 dui-text-center'>{host}</span>
            <Button
              buttonType="SECONDARY"
              buttonSize="EXTRA_SMALL"
              rightIcon={<FaPlus />}
              onClick={() =>
                onFilterSelect(
                  history.location,
                  dispatch,
                  props.filterAction,
                  FILTERS.HOST,
                  host + 1
                )
              }
              disabled={!!host}
            />
          </div>
        </div>
      </div>
    </div>
  ) : <Button buttonType="LINK" onClick={props.filterModalToggle} leftIcon={<IoPeopleOutline />}>{selectedFilterText || 'Crew'}</Button>;
};
Crew.propTypes = {
  weeks: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
  setPage: PropTypes.func,
  mobile: PropTypes.bool,
  filterModalToggle: PropTypes.bool,
  className: PropTypes.string,
  renderFilterMenuButton: PropTypes.bool,
  filterAction: PropTypes.func.isRequired
};
export default Crew;
